import { render } from "./Carte.vue?vue&type=template&id=10e472e6"
import script from "./Carte.vue?vue&type=script&lang=js"
export * from "./Carte.vue?vue&type=script&lang=js"

import "./Carte.vue?vue&type=style&index=0&id=10e472e6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__